module.exports = __webpack_public_path__ + "img/fazhanlicheng.a02c366c.png";